{
  "ENROLLMENT_CREATED": {
    "title": "New course available!",
    "message": "You have been enrolled in {{productTitle}}"
  },
  "COURSE_COMPLETED": {
    "title": "Course completed!",
    "message": "Congratulations! You completed {{productTitle}}"
  },
  "LESSON_COMPLETED": {
    "title": "Lesson completed!",
    "message": "You completed \"{{lessonTitle}}\""
  },
  "POINTS_EARNED": {
    "title": "Points earned!",
    "message": "You earned {{points}} XP"
  },
  "COMMUNITY_POINTS_EARNED": {
    "title": "+{{points}} XP in the Community!",
    "message": "You earned {{points}} XP in the community"
  },
  "LEVEL_UP": {
    "title": "Level reached!",
    "message": "You moved up to {{levelName}}"
  },
  "COMMENT_REPLY": {
    "title": "New reply to your comment",
    "message": "{{replierName}} replied: \"{{snippet}}\""
  },
  "COMMENT_REACTION": {
    "title": "Your comment got a like",
    "message": "{{reactorName}} liked your comment"
  },
  "PAYMENT_APPROVED": {
    "title": "Payment confirmed",
    "message": "Your payment for {{offerName}} was approved"
  },
  "DAILY_CHECKLIST_TASK": {
    "title": "Daily checklist",
    "message": "You completed the task: {{actionLabel}}! +{{points}} XP"
  },
  "DAILY_CHECKLIST_BONUS": {
    "title": "Daily trifecta complete!",
    "message": "Congratulations! You completed every daily task and earned a +{{bonusPoints}} XP bonus!"
  },
  "STREAK_MILESTONE": {
    "title": "{{streakDays}} days in a row!",
    "message": "{{streakDays}} days of studying in a row!",
    "message_7": "Congratulations! 7 days of studying in a row! 🔥",
    "message_14": "Impressive! 2 weeks of studying in a row! 🚀",
    "message_30": "AMAZING! 30 days in a row! You are unstoppable! ⭐",
    "message_60": "Legend! 60 days of pure discipline! 🏆",
    "message_90": "EPIC! 90 days in a row! You are an inspiration! 💎",
    "message_180": "LEGENDARY! 6 months of total dedication! 👑",
    "message_365": "SUPREME! 1 FULL YEAR! You made history! 🌟"
  },
  "STREAK_BROKEN": {
    "title": "Your streak was broken",
    "message": "Your {{brokenStreak}}-day streak was broken. Do not give up, start a new one today!"
  },
  "CHALLENGE_COMPLETED": {
    "title": "Challenge completed!",
    "message": "Congratulations! You completed the \"{{challengeTitle}}\" challenge!"
  },
  "WEEKLY_BADGE_EARNED": {
    "title": "Weekly badge earned!",
    "message": "Congratulations! You placed #{{rank}} this week and earned the \"{{badgeName}}\" badge!"
  },
  "REWARD_REDEEMED": {
    "title": "Reward redeemed!",
    "message": "You redeemed \"{{rewardTitle}}\" for {{costXp}} XP!"
  },
  "REWARD_STATUS_UPDATED": {
    "title": "Reward status updated",
    "message": "The status of your \"{{rewardTitle}}\" redemption was updated.",
    "message_pending": "Your \"{{rewardTitle}}\" redemption is being processed.",
    "message_processing": "Your \"{{rewardTitle}}\" redemption is in progress.",
    "message_delivered": "Your \"{{rewardTitle}}\" redemption was delivered!",
    "message_cancelled": "Your \"{{rewardTitle}}\" redemption was cancelled and the XP was refunded."
  },
  "ADMIN_REDEMPTION_ALERT": {
    "title": "New redemption request",
    "message": "A user redeemed \"{{rewardTitle}}\". Action required."
  },
  "checklistActions": {
    "post": "post",
    "comment": "comment",
    "like": "like"
  }
}
